import { apiRequest } from "@/api/client";
import { TTL_SESSION, cacheKey, cachedFetch } from "@/lib/api-cache";
import type { CnaeOption, Municipio, NaturezaOption, StaticLookups } from "@/types/api";

// Lookups são estáticos no mês → cache de sessão (não expira).

/** Lookups estáticos: situações, portes e UFs. */
export function fetchStaticLookups(): Promise<StaticLookups> {
  return cachedFetch(cacheKey("GET /lookups/static", null), TTL_SESSION, () =>
    apiRequest<StaticLookups>("/lookups/static"),
  );
}

/** Municípios de uma UF (para o select dependente). */
export function fetchMunicipios(uf: string): Promise<Municipio[]> {
  return cachedFetch(cacheKey("GET /lookups/municipios", uf), TTL_SESSION, () =>
    apiRequest<Municipio[]>(`/lookups/municipios?uf=${encodeURIComponent(uf)}`),
  );
}

/** Busca de CNAEs por prefixo de código ou nome (máx. 20). */
export function searchCnaes(query: string, _signal?: AbortSignal): Promise<CnaeOption[]> {
  return cachedFetch(cacheKey("GET /lookups/cnaes", query), TTL_SESSION, () =>
    apiRequest<CnaeOption[]>(`/lookups/cnaes?q=${encodeURIComponent(query)}`),
  );
}

/** Busca de naturezas jurídicas por código ou nome (máx. 20). */
export function searchNaturezas(query: string, _signal?: AbortSignal): Promise<NaturezaOption[]> {
  return cachedFetch(cacheKey("GET /lookups/naturezas", query), TTL_SESSION, () =>
    apiRequest<NaturezaOption[]>(`/lookups/naturezas?q=${encodeURIComponent(query)}`),
  );
}
